import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getGuideDetailList as getGuideDetailListApi,
	getGuideDetail as getGuideDetailApi,
	addNewGuideDetail as addNewGuideDetailApi,
	updateGuideDetail as updateGuideDetailApi,
	deleteGuideDetail as deleteGuideDetailApi,
	warehouseSendFromStock as warehouseSendFromStockApi,
	warehouseSendFromGuideLines as warehouseSendFromGuideLinesApi,
} from '../../helpers/residue/backend_helper';

export const getGuideDetailList = createAsyncThunk('guideDetails/getGuideDetailList', async (params) => {
	try {
		const response = getGuideDetailListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getGuideDetail = createAsyncThunk('guideDetails/getGuideDetail', async guideDetail_id => {
	try {
		const response = getGuideDetailApi(guideDetail_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewGuideDetail = createAsyncThunk('guideDetails/addNewGuideDetail', async guideDetail => {
	try {
		const response = addNewGuideDetailApi(guideDetail);
		toast.success('GuideDetail agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar guideDetail.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateGuideDetail = createAsyncThunk('guideDetails/updateGuideDetail', async (guideDetail) => {
		try {
			const response = updateGuideDetailApi(guideDetail);
			toast.success('GuideDetail actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar guideDetail.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteGuideDetail = createAsyncThunk('guideDetails/deleteGuideDetail', async guideDetail => {
	try {
		const response = await deleteGuideDetailApi(guideDetail);
		toast.success('GuideDetail eliminado exitosamente.', { autoClose: 3000 });
		return { guideDetail, ...response };
	} catch (error) {
		toast.error('Error al eliminar guideDetail.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const warehouseSendFromStock = createAsyncThunk('guideDetails/warehouseSendFromStock', async dataGuides => {
	try {
		const response = await warehouseSendFromStockApi(dataGuides);
		toast.success('Residuos enviados desde stock exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al enviar residuos desde stock.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const warehouseSendFromGuideLines = createAsyncThunk(
	'guideDetails/warehouseSendFromGuideLines',
	async sendData => {
		try {
			const response = await warehouseSendFromGuideLinesApi(sendData);
			toast.success('Guías consolidadas desde líneas recepcionadas.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			const detail =
				error?.response?.data?.detail ||
				error?.message ||
				'Error al enviar desde líneas de guía';
			toast.error(detail, { autoClose: 5000 });
			throw error;
		}
	},
);